<template>
  <div class="unity-wrapper" style="width: 100%; height: 100%">
    <div v-if="!unityWebGLLink">
      <img :src="currentCoverImagePath" />
    </div>
    <iframe id="unity-frame" v-if="unityWebGLLink" :src="unityWebGLLink" allowfullscreen v-show="isUnityIframeShow"></iframe>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, computed, nextTick } from 'vue';
import { useStore } from 'vuex';

const isUnityIframeShow = ref(false); // 是否顯示 Unity 畫面 等待初始化視窗調整完畢後才顯示
const unityWebGLLink = ref(null); // Unity WebGL 連結
const currentCoverImagePath = ref(null); // 蓋版圖路徑

import mobileWebGLImage from '@/assets/img/streaming/streaming_webgl_mobile.jpg'; // 行動裝置進入 WebGL 蓋版圖
import loginWebGLImage from '@/assets/img/streaming/stream_webgl_login.jpg'; // 未登入進入支援 WebGL 頁面時蓋版圖
const mobileWebGLImagePath = mobileWebGLImage;
const loginWebGLImagePath = loginWebGLImage;

const store = useStore();
const jwt = computed(() => store.state.jwt);

const props = defineProps({
  streamingInfo: {
    type: Object,
    default: require,
  },
});

watch(
  () => props,
  async (newVal) => {
    var mobile = require('is-mobile');
    if (mobile()) {
      currentCoverImagePath.value = mobileWebGLImagePath;
      return;
    } else if (!jwt.value) {
      currentCoverImagePath.value = loginWebGLImagePath;
      return;
    }

    // 載具非手機 & 玩家有登入 才傳入連結 沒有連結會自動顯示蓋板圖
    unityWebGLLink.value = newVal.streamingInfo?.webGLLink;

    await nextTick();
    initializeUnityCanvas();
  },
  { immediate: true },
);

function initializeUnityCanvas() {
  isUnityIframeShow.value = true;
}
</script>

<style lang="scss">
@import '@/assets/styles/pages/memberCenter/streamingProgram.scss';
</style>
